import { OrderWizardActionTypes as actions } from '../../order-wizard/store/action-types'
import { LoyaltyOption } from '../../order-wizard/models/LoyaltyOption'

const productConfigMixin = {
  data () {
    return {
      possibleLoyalties: [],
      groups: null
    }
  },

  methods: {
    async getProductConfig () {
      const config = await this.$store.dispatch(actions.GET_PRODUCT_CONFIGURATION)
      config.possibleLoyalties.forEach(value => {
        let labelKey = value === 0 ? 'package_selector.no_loyalty' : 'package_selector.loyalty'
        this.possibleLoyalties.push(new LoyaltyOption({ value, labelKey }))
      })
      this.groups = config.productGroups
    }
  }
}

export default productConfigMixin
